import { render } from "./AddCategorieFaqModal.vue?vue&type=template&id=417815f2&ts=true"
import script from "./AddCategorieFaqModal.vue?vue&type=script&lang=ts"
export * from "./AddCategorieFaqModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__